// extracted by mini-css-extract-plugin
module.exports = {"preloader-container":"Preloader_preloader-container__GFTVu","ldio":"Preloader_ldio__YQl0m","loadingio-spinner-spin":"Preloader_loadingio-spinner-spin__G2GEC"};